import { render } from "./CharlaFormPopup.vue?vue&type=template&id=55587864&scoped=true"
import script from "./CharlaFormPopup.vue?vue&type=script&lang=js"
export * from "./CharlaFormPopup.vue?vue&type=script&lang=js"

import "./CharlaFormPopup.vue?vue&type=style&index=0&id=55587864&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55587864"]])

export default __exports__